import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	tryItNowButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		defaultMessage: 'Assess risk with Rovo Ops',
		description:
			'Heading for the spotlight that introduces the assess risk button powered by Rovo Ops',
		id: 'alexstrasza.assess-risk-button-spotlight.heading',
	},
	description: {
		defaultMessage: 'Evaluate the potential impact of this change before approving or scheduling.',
		description:
			'Description for the spotlight that introduces the assess risk button powered by Rovo Ops',
		id: 'alexstrasza.assess-risk-button-spotlight.description',
	},
	tryItNowButton: {
		defaultMessage: 'Try it now',
		description: 'Primary action button that opens the risk assessment panel',
		id: 'alexstrasza.assess-risk-button-spotlight.try-it-now',
	},
});
